<template>
    <svg :width="size" :height="size" viewBox="0 0 14 14" :fill="color" xmlns="http://www.w3.org/2000/svg" class="two-squares-with-overlapping-corners">
    <path opacity="0.4"
        d="M4.33301 3.00016C4.33301 1.5274 5.52692 0.333496 6.99967 0.333496H10.9997C12.4725 0.333496 13.6664 1.5274 13.6664 3.00016V7.00016C13.6664 8.47292 12.4725 9.66683 10.9997 9.66683H6.99968C5.52692 9.66683 4.33301 8.47292 4.33301 7.00016V3.00016Z"
        :fill="color" />
    <path
        d="M0.333008 7.00016C0.333008 5.5274 1.52692 4.3335 2.99967 4.3335H6.9997C8.47246 4.3335 9.66636 5.5274 9.66636 7.00016V11.0002C9.66636 12.4729 8.47246 13.6668 6.9997 13.6668H2.99968C1.52692 13.6668 0.333008 12.4729 0.333008 11.0002V7.00016Z"
        :fill="color" />
</svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#71767D',
        },
        size: {
            type: String,
            default: 14,
        },
        hoverColor: {
            type: String,
            default: '#4f5357',
        },
    },
};
</script>

<style scoped>
.two-squares-with-overlapping-corners:hover path {
    fill: v-bind(hoverColor);
}
</style>